export const formatCurrency = (val, decimals = 1) => {
  if (val == null) return '—';
  return `₹${Number(val).toFixed(decimals)}L`;
};

export const formatPct = (val, decimals = 1) => {
  if (val == null) return '—';
  return `${Number(val).toFixed(decimals)}%`;
};

export const getAchColor = (pct) => {
  if (pct >= 100) return 'status-excellent';
  if (pct >= 90) return 'status-good';
  if (pct >= 80) return 'status-warn';
  return 'status-poor';
};

export const getGrowthColor = (pct) => {
  if (pct > 0) return 'growth-positive';
  if (pct < 0) return 'growth-negative';
  return 'growth-neutral';
};

export const calcDeficit = (target, actual) => {
  if (!target || !actual) return 0;
  return Math.max(0, target - actual);
};

export const formatNumber = (val, decimals = 1) => {
  if (val == null) return '—';
  return Number(val).toFixed(decimals);
};